import createAction from '../../common/services/create-action';

export const SET_FEED_TITLE = 'feedTitle/SET';

export const setFeedTitle = createAction(SET_FEED_TITLE);
